import { render, staticRenderFns } from "./ModalStockHistory.vue?vue&type=template&id=56fd22ff"
import script from "./ModalStockHistory.vue?vue&type=script&lang=js"
export * from "./ModalStockHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports